import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

import { useEmployeeHistoryTableData } from '../hooks/use-employee-history-table-data'
import { EmployeeHistory } from '../types/employee-history'
import CompanyApiTableTab from './CompanyApiTableTab'

/**
 * The component provides employee history for the selected company
 */
const CompanyUsersHistory: React.FC = () => {
  const { t } = useCustomTranslation()
  const { columns, fetchProps } = useEmployeeHistoryTableData()

  return (
    <CompanyApiTableTab<EmployeeHistory>
      columns={columns}
      fetchProps={fetchProps}
      title={t('administration.companies.empl-history.tab')}
      tabKey={2}
    />
  )
}

export default CompanyUsersHistory
